import UserControllerAuthentication from './authentication'
import UserControllerInvite from './invite'
import UserControllerOrganization from './organization'
import UserControllerUser from './user'
import SmartInsightController from './smartinsight'
import BusinessProfilesController from './businessProfiles'
import UserControllerAuthorization from './authorization'
import ContactController from './contact'
import PrivateDataAccessController from './privateDataAccess'
import UserControllerOrganizationCustomization from './OrganizationCustomization'
import UserControllerSurvey from './survey'

export default class UserService {
  public organization = new UserControllerOrganization()
  public authentication = new UserControllerAuthentication()
  public user = new UserControllerUser()
  public invite = new UserControllerInvite()
  public smartInsight = new SmartInsightController()
  public businessProfiles = new BusinessProfilesController()
  public authorization = new UserControllerAuthorization()
  public contact = new ContactController()
  public privateDataAccess = new PrivateDataAccessController()
  public organizationCustomization =
    new UserControllerOrganizationCustomization()
  public survey = new UserControllerSurvey()
}
